import { createContext } from "react"

export const WdCredentialsContext = 
    createContext<{wdImplementerId: string; setWdImplementerId: React.Dispatch<React.SetStateAction<string>>; wdImplementerPwd: string; setWdImplementerPwd: React.Dispatch<React.SetStateAction<string>>;}>
    ({ wdImplementerId: "", setWdImplementerId: () => {}, wdImplementerPwd: "", setWdImplementerPwd: () => {}});